"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnce = exports.useEffect = void 0;
const decorator_1 = require("./decorator");
function useEffect(element, on, observe) {
    const effect = (0, decorator_1.withEffect)(element, {
        on,
        observe: ["__initial__dirty"],
    });
    effect.observe.some((o, index) => observe[index] !== o) && effect.on();
    effect.observe = observe;
}
exports.useEffect = useEffect;
const useOnce = (element, on) => useEffect(element, on, []);
exports.useOnce = useOnce;
//# sourceMappingURL=effect.js.map